import React from "react";
import ReactDOM from "react-dom/client";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

// admin_lte

import "./index.css";
import App from "./App";
import { FrontPage } from "./views/FrontPage";
import { Home } from "./views/Home";
import { Deposit } from "./views/Deposit";
import { Withdraw } from "./views/Report/Withdraw";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/Authcontext";
import { Withdrawreport } from "./views/Report/Withdrawreport";
import { Depositereport } from "./views/Report/Depositereport";
import { Changepassword } from "./views/Report/Changepassword";
import { Stakebutton } from "./views/Report/Stakebutton";
import { Result } from "./views/Report/Result";
import { Activitylogs } from "./views/Report/Activitylogs";
import { Plstatement } from "./views/Report/Plstatement";
import { Accountstatement } from "./views/Report/Accountstatement";
import SportsBook from "./views/Report/SportsBook";
// import { Home } from './views/home';
import Dashboard from "./views/admin/Dashboard";

// Make jQuery globally available
import $ from "jquery";
import AdminUsers from "./views/admin/components/AdminUsers";
import AdminUserSetting from "./views/admin/components/userSetting";
import AdminSettings from "./views/admin/components/AdminSettings";
import AdminRoles from "./views/admin/components/AdminRoles";
import AdminMatches from "./views/admin/components/AdminMatches";
import ManageMarket from "./views/admin/components/ManageMarket";
import MyMarket from "./views/admin/components/MyMarket";
import MatchesHistory from "./views/admin/components/MatchesHistory";
import FancyHistory from "./views/admin/components/FancyHistory";
import ManageFancy from "./views/admin/components/ManageFancy";
import Bonus from "./views/admin/components/Bonus";
// import Bank from "./views/admin/components/Bank";
import AdminAddRoles from "./views/admin/components/AdminAddRoles";
import ProtectedRoute from "./views/admin/ProtectedRoute";
import AdminLogin from "./views/admin/AdminLogin";
import BrowseRecharge from "./views/admin/components/BrowseRecharge";
import BrowseWithdrawl from "./views/admin/components/BrowseWithdrawl";
import SportsBets from "./views/Report/SportsBets";
import ProfitLoss from "./views/admin/components/ProfitLoss";
import DepositHistory from "./views/admin/components/DepositHistory";
import WithdrawHistory from "./views/admin/components/WithdrawHistory";
import { Toaster } from "react-hot-toast";
import Admin from "./views/admin/components/Admin";
import Jili from "./views/Jili";
import ProtectedRouteUser from "./views/components/ProtectedRouteUser";
import AviatorGames from "./views/AviatorGames";
import ContactUs from "./views/ContactUs";
import CookiePolicy from "./views/CookiePolicy";
import TurboGames from "./views/GamingProviders/TurboGames";
import EvolutionGames from "./views/GamingProviders/EvolutionGames";
import EzugiGames from "./views/GamingProviders/EzugiGames";
import RedTiger from "./views/GamingProviders/RedTiger";
import MaccGames from "./views/GamingProviders/MaccGames";
import JdbGaming from "./views/GamingProviders/JdbGaming";
import BetHistory from "./views/admin/components/BetHistory";
import Lobby from "./views/GamingProviders/Lobby";
import LiveCasino from "./views/GamingProviders/LiveCasino";
import Master from './views/admin/components/Master';
import AddSlider from "./views/admin/components/AddSlider";
import Slider from "./views/admin/components/Slider";
import SuperMaster from "./views/admin/components/SuperMaster";
import JiliAll from "./views/JiliAll";
import JDBAll from "./views/JDBAll";
import SportHistory from "./views/admin/components/SportHistory";
import Cricket from "./views/Cricket";
import SuperAdmin from "./views/admin/components/SuperAdmin";
import Agent from "./views/admin/components/Agent";
import EditSlider from "./views/admin/components/EditSlider";
import PgSoftAll from "./views/PgSoftAll";
import CQ9All from "./views/CQ9All";
import RummyHome from "./views/GamingProviders/RummyHome";
import SpribeHome from "./views/GamingProviders/SpribeHome";
import CQ9Home from "./views/GamingProviders/CQ9Home";
import PgSoftHome from "./views/GamingProviders/PgSoftHome";
import TurboAll from "./views/TurboAll";
import SuperAdminChip from "./views/admin/components/SuperAdminChip";
import UserChip from "./views/admin/components/UserChip";
import Profile from "./views/admin/components/Profile";
import Menu from "./views/Menu";
import CommissionHistory from "./views/admin/components/CommissionHistory";
import AdminBonus from "./views/admin/components/AdminBonus";
import CricketAll from "./views/CricketAll";
import UserStatment from "./views/admin/components/UserStatement";
import WeekReport from "./views/admin/components/WeekReport";
import CategoryGrid from "./views/components/CategoryGrid";
import Register from "./views/RegisterForm";


import CricketReal from "./views/CricketReal";
import FootballReal from "./views/FootballReal";
import TennisReal from "./views/TennisReal";
import FootBAll from "./views/FootBall";
import Tennis from "./views/Tennis";
import Inplays from "./views/Inplays";
import CasinoGames from "./views/CasinoGames";
import CasinoHistory from "./views/admin/components/CasinoHistory";
import UserBetHistory from "./views/admin/components/UserBetHistory";
import UserSportsSetting from "./views/admin/components/UserSportsSetting";
import PromoCode from "./views/admin/components/PromoCode";
import AdminBankList from "./views/admin/components/AdminBankList";
import MarketAnalysis from "./views/admin/components/MarketAnalysis";


import WeeklyReportsUser from "./views/admin/components/WeeklyReportsUser";
import MarketAnalysisBets from "./views/admin/components/MarketAnalysisBets";
import MarketAnalysisFootBallBets from "./views/admin/components/MarketAnalysisFootBallBets";
import MarketAnalysisTennisBets from "./views/admin/components/MarketAnalysisTennisBets";
import { ThemeProvider } from "./context/ThemeContext";
import EditLogo from "./views/admin/components/EditLogo";
import EditModal from "./views/admin/components/EditModal";
import LoginReg from "./views/LoginReg";
import Settlement from "./views/admin/components/Settlement";
import SettleHistory from "./views/admin/components/SettleHistory";
import FancyBetsResult from "./views/admin/components/FancyBetsResult";
import DeletedBets from "./views/admin/components/DeletedBets";
import HomeCricket from "./views/admin/components/HomeCricket";
import HomeFootball from "./views/admin/components/HomeFootball";
import HomeTennis from "./views/admin/components/HomeTennis";
import AdminHome from "./views/admin/components/AdminHome";
import DelayPage from "./views/admin/components/DelayPage";
import MatchHistoryManage from "./views/admin/components/MatchHistoryManage";
import GetAllMatchBet  from "./views/admin/components/GetAllMatchBet";
import ChildUsers from "./views/admin/components/ChildUsers";
import AdminLayout from "./views/admin/AdminLayout";
import NewClientPage from "./views/admin/NewClientPage";

// import GlobalSearch from "./views/admin/components/GlobalSearch";



window.jQuery = $;
window.$ = $;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <AuthProvider>
      <ThemeProvider>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route path="/" element={<LoginReg />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<LoginReg />} />

        <Route element={<ProtectedRouteUser />}>
          <Route path="/changepassword" element={<Changepassword />} />
          <Route path="/stakebutton" element={<Stakebutton />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/withdrawhistory" element={<Withdrawreport />} />
          <Route path="/depositehistory" element={<Depositereport />} />
          <Route path="/result" element={<Result />} />
          <Route path="/activitylogs" element={<Activitylogs />} />
          <Route path="/plstatement" element={<Plstatement />} />
          <Route path="/accountstatement" element={<Accountstatement />} />
        </Route>
      

        <Route path="/jiliAll" element={<JiliAll />} />
        <Route path="/jdbAll" element={<JDBAll />}/>
        <Route path="/pgsoftAll" element={<PgSoftAll />}/>
        <Route path="/cq9All" element={<CQ9All />}/>
        <Route path="/rummyHome" element={<RummyHome />}/> 
        <Route path="/spribeHome" element={<SpribeHome />}/>                      
        <Route path="/cQ9Home" element={<CQ9Home />}/>                      
        <Route path="/pgSoftHome" element={<PgSoftHome />}/>
        <Route path="/turboAll" element={<TurboAll />}/>

        {/* <Route path='/games' element={<Games/>}/>
          <Route path='/sports/:id' element={<Sports/>}/> */}
        <Route path="/live-casino" element={<LiveCasino/>}/>
        <Route path="/jili" element={<Jili />} />
        <Route path="/turbo-games" element={<TurboGames/>}/>
        <Route path="/evolution-games" element={<EvolutionGames/>}/>
        <Route path="/ezugi-games" element={<EzugiGames/>}/>
        <Route path="/redtiger-games" element={<RedTiger/>}/>
        <Route path="/macc-games" element={<MaccGames/>}/>
        <Route path="/jdb-games" element={<JdbGaming/>}/>
        <Route path="/aviator-games" element={<AviatorGames/>}/>
        <Route path="/sportsbook" element={<SportsBook />} />
        <Route path="/sports_bets" element={<SportsBets />} />
        <Route path="/contact-us" element={<ContactUs/>}/>
        <Route path="/cookie-policy" element={<CookiePolicy/>}/>
        <Route path="/app" element={<App />} />
        <Route path="/lobby" element={<Lobby/>}/>
        <Route path="/cricketBet" element={<Cricket />}/>
        <Route path="/footBAllBet" element={<FootBAll />}/>
        <Route path="/tennis" element={<Tennis />}/> 
        <Route path="/menu" element={<Menu />}/>
        <Route path="/sportall" element={<CricketAll />}/>
        <Route path="/CategoryGrid" element={<CategoryGrid />}/>
        <Route path="/registerPage" element={<Register />}/>
        <Route path="/cricketreal" element={<CricketReal />}/>
        <Route path="/footballreal" element={<FootballReal />}/>
        <Route path="/tennisreal" element={<TennisReal />}/>
        <Route path="/inplay" element={<Inplays />}/>
        <Route path="/casinoGames" element={<CasinoGames />}/>


        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
       <Route path="/admin" element={<AdminLayout />}>
    
    {/* Default dashboard */}
    <Route index element={<Dashboard />} />
    <Route path="dashboard" element={<Dashboard />} />

    <Route path="Admin" element={<Admin />} />
    <Route path="user" element={<AdminUsers />} />


    <Route path="userSetting/:user_phone/:user_code" element={<AdminUserSetting />} />
    <Route path="userSetting/:user_phone" element={<AdminUserSetting />} />
    <Route path="userBetHistory/:user_phone" element={<UserBetHistory />} />
    <Route path="userWeeklyReport/:user_phone" element={<WeeklyReportsUser />} />

    <Route path="browse_recharge" element={<BrowseRecharge />} />
    <Route path="browse_withdrawl" element={<BrowseWithdrawl />} />
    <Route path="settings" element={<AdminSettings />} />
  

    <Route path="roles" element={<AdminRoles />} />
    <Route path="matches" element={<AdminMatches />} />
    <Route path="deposit_history" element={<DepositHistory />} />
    <Route path="withdraw_history" element={<WithdrawHistory />} />

    <Route path="manage_market" element={<ManageMarket />} />
    <Route path="my_market" element={<MyMarket />} />
    <Route path="matches_history" element={<MatchesHistory />} />

    <Route path="userSportsSetting/:phone" element={<UserSportsSetting />} />
    <Route path="fancyHistory" element={<FancyHistory />} />
    <Route path="manageFancy" element={<ManageFancy />} />

    <Route path="bonus" element={<Bonus />} />
    <Route path="add_roles" element={<AdminAddRoles />} />
    <Route path="profitloss" element={<ProfitLoss />} />

    <Route path="betHistory" element={<BetHistory />} />
    <Route path="master" element={<Master />} />
    <Route path="supermaster" element={<SuperMaster />} />
      <Route path="Agent" element={<Agent />}/>
    <Route path="superAdmin" element={<SuperAdmin />}/>
    <Route path="slider" element={<Slider />} />
    <Route path="addSlider" element={<AddSlider />} />
    <Route path="editSlider/:id" element={<EditSlider />} />
    <Route path="editLogo/:id" element={<EditLogo />} />
    <Route path="editModal/:id" element={<EditModal />} />

    <Route path="adminChip" element={<SuperAdminChip />} />
    <Route path="userChip" element={<UserChip />} />
    <Route path="Profile" element={<Profile />} />

    <Route path="commissionHistory" element={<CommissionHistory />} />
    <Route path="adminbonus" element={<AdminBonus />} />

    <Route path="userStatement" element={<UserStatment />} />
    <Route path="userStatement/:id" element={<UserStatment />} />

    <Route path="casinohistory" element={<CasinoHistory />} />
    <Route path="bankList" element={<AdminBankList />} />

    <Route path="marketAnalysis" element={<MarketAnalysis />} />
    <Route path="cricket/marketBetAnalysis/:marketId2" element={<MarketAnalysisBets />} />
    <Route path="tennis/marketBetAnalysis/:marketId2" element={<MarketAnalysisTennisBets />} />
    <Route path="football/marketBetAnalysis/:marketId2" element={<MarketAnalysisFootBallBets />} />

    <Route path="newclient" element={<NewClientPage />} />
    {/* <Route path="global" element={<GlobalSearch />} /> */}
    <Route path="getChildUsers/:code" element={<ChildUsers />} />
    <Route path="getfancybets/:eventid" element={<FancyBetsResult />} />

    {/* <Route path="exposure/:phone" element={<Exposure />} /> */}
    {/* <Route path="eventDelay" element={<EventDelay />} /> */}
    <Route path="page/eventDelay" element={<DelayPage />} />

    {/* <Route path="liveBets" element={<LiveBets />} /> */}
    {/* <Route path="matchSummary" element={<MatchSummary />} /> */}
    {/* <Route path="todaySummary" element={<TodayReport />} />
    <Route path="lossback" element={<LossBack />} /> */}

    <Route path="weekReport" element={<WeekReport />} />
    <Route path="settleHistory" element={<SettleHistory />} />
    <Route path="settlement" element={<Settlement />} />
   <Route path="sportHistory" element={<SportHistory />}/>
    <Route path="home" element={<AdminHome />} />
    <Route path="homecricket" element={<HomeCricket />} />
    <Route path="homefootball" element={<HomeFootball />} />
    <Route path="hometennis" element={<HomeTennis />} />
    <Route path="getDeleteBets" element={<DeletedBets />} />
    <Route path="fancyBetsResult" element={<FancyBetsResult />} />

    {/* <Route path="newRegister" element={<NewUserRegister />} />
    <Route path="betUpdateResult" element={<BetUpdateResult />} />
    <Route path="eventBetHistory/:eventId" element={<EventBetHistory />} /> */}


     <Route path="/admin/matchHistoryManage" element={<MatchHistoryManage />}/>
          <Route path="/admin/getAllMatchBet/:eventId" element={<GetAllMatchBet />}/>
     

  </Route>
      </Routes>
      </ThemeProvider>
    </AuthProvider>

     
   
    
  </Router>
);

reportWebVitals();